import type { ContentVisibility } from '@/types/database';

export type PrivacyTier = 'open' | 'standard' | 'members';

export interface PrivacyTierOption {
  id: PrivacyTier;
  name: string;
  description: string;
}

// Spec's 3-tier privacy posture (see docs/site-builder-overhaul.md's Phase
// C). 'standard' has no visible effect yet — its differentiator (gated
// photo gallery, gated documents) has no corresponding module built yet
// (see Phase F). It's kept selectable now, described honestly, so a unit
// that wants it doesn't have to redo this choice once those modules ship.
export const PRIVACY_TIERS: PrivacyTierOption[] = [
  {
    id: 'open',
    name: 'Open front door',
    description: 'Public homepage, join page, and calendar. The best choice for recruiting new families.',
  },
  {
    id: 'standard',
    name: 'Standard',
    description:
      'Same as Open front door today. Photo galleries and documents will be gated behind sign-in automatically once those features ship.',
  },
  {
    id: 'members',
    name: 'Members only',
    description: 'Only your Join and Contact pages stay public. Everything else requires sign-in. This suppresses recruiting.',
  },
];

// Recruiting-critical pages stay public even under 'members' — a family
// that can't find or reach the unit can't join it.
const ALWAYS_PUBLIC_SLUGS = ['home', 'join', 'contact'];

export function visibilityForPage(tier: PrivacyTier, pageSlug: string): ContentVisibility {
  if (tier === 'members' && !ALWAYS_PUBLIC_SLUGS.includes(pageSlug)) return 'internal';
  return 'public';
}
